import React, {Component} from 'react';
import {
    Link,
    Redirect
} from "react-router-dom";
import {Formik, Field, FieldArray} from 'formik';
import _ from 'lodash';
import config from '../config';
import {AuthContext} from "../context/auth";
import fetcher from "../context/fetcher";
import {SchedulePicker} from "../components/schedule-picker"

export default class Leaderboards extends Component {
    static contextType = AuthContext

    constructor(props, context) {
        super(props);
        this.authContext = context;
        this.state = {}
        this.init = this.init.bind(this);
    }

    componentDidMount() {
        this.init();
    }

    async init() {
        let responseItems = await fetcher(`${config.API()}leaderboards/list`);
        let resp = await responseItems.json();
        this.setState({
            items: resp.items
        })
    }
    render() {
        let list = []
        if (this.state.items)
            for (let item of this.state.items) {
                list.push(<tr key={item}>
                    <td><Link to={`/leaderboards/${encodeURIComponent(item)}`}>{item}</Link></td>
                </tr>)
            }
        return (
            <div>
                <div className="card shadow w100">
                    <div className="card-header py-3">
                        <h2 className="m-0 font-weight-bold l">Leaderboards </h2>
                    </div>
                    <div className="card-body">
                        <div className="table-responsive">
                            <table className="dataTable table table-align-middle table-bordered table-sm" width="100%"
                                   cellSpacing="0">
                                <thead>
                                <tr>
                                    <th>Id</th>
                                </tr>
                                </thead>
                                <tbody>
                                {list}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}